import type { UIMessage } from 'ai';

/**
 * Module-level assistant state, so the open conversation survives the panel
 * unmounting (closing it, navigating) without any persistence machinery. The
 * durable record is server-side — each exchange auto-saves to the caller's
 * personal chat history — this store only keeps the live session warm.
 */

let savedMessages: UIMessage[] = [];

/** The conversation as of the last time the panel was open. */
export function getSavedMessages(): UIMessage[] {
  return savedMessages;
}

/** Saves the conversation (called on every message change while open). */
export function saveMessages(messages: UIMessage[]): void {
  savedMessages = messages;
}

/** Empties the saved conversation (starting a new chat). */
export function clearSavedMessages(): void {
  savedMessages = [];
}

let openListener: (() => void) | null = null;

/** Registers the shell's "open the assistant panel" handler (one at a time). */
export function onAssistantOpenRequest(listener: (() => void) | null): void {
  openListener = listener;
}

/** Asks the shell to open the assistant panel — e.g. "Continue this chat". */
export function requestAssistantOpen(): void {
  openListener?.();
}

let currentChatId: string | null = null;

/** The server-side chat the open conversation is saved into, if any. */
export function getCurrentChatId(): string | null {
  return currentChatId;
}

/** Records which server-side chat the open conversation belongs to. */
export function setCurrentChatId(id: string | null): void {
  currentChatId = id;
}
